/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_165_TitleInputs */

const en_tree_type_165_title = /** @type {(inputs: Tree_Type_165_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscat Macaron`)
};

const ar_tree_type_165_title = /** @type {(inputs: Tree_Type_165_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ماكارون مسقط`)
};

const de_tree_type_165_title = /** @type {(inputs: Tree_Type_165_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muskat-Macaron`)
};

const es_tree_type_165_title = /** @type {(inputs: Tree_Type_165_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron de moscatel`)
};

const fr_tree_type_165_title = /** @type {(inputs: Tree_Type_165_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron au muscat`)
};

const it_tree_type_165_title = /** @type {(inputs: Tree_Type_165_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron al moscato`)
};

const ja_tree_type_165_title = /** @type {(inputs: Tree_Type_165_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マスカットマカロン`)
};

const ko_tree_type_165_title = /** @type {(inputs: Tree_Type_165_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`머스캣 마카롱`)
};

const pt_br_tree_type_165_title = /** @type {(inputs: Tree_Type_165_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron de Moscato`)
};

const ru_tree_type_165_title = /** @type {(inputs: Tree_Type_165_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мускатный макарон`)
};

const th_tree_type_165_title = /** @type {(inputs: Tree_Type_165_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มาการองมัสแคต`)
};

const tr_tree_type_165_title = /** @type {(inputs: Tree_Type_165_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misket Üzümlü Makaron`)
};

const zh_cn_tree_type_165_title = /** @type {(inputs: Tree_Type_165_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`青提马卡龙`)
};

const zh_tw_tree_type_165_title = /** @type {(inputs: Tree_Type_165_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`白葡萄馬卡龍`)
};

/**
* | output |
* | --- |
* | "Muscat Macaron" |
*
* @param {Tree_Type_165_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_165_title = /** @type {((inputs?: Tree_Type_165_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_165_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_165_title(inputs)
	if (locale === "ar") return ar_tree_type_165_title(inputs)
	if (locale === "de") return de_tree_type_165_title(inputs)
	if (locale === "es") return es_tree_type_165_title(inputs)
	if (locale === "fr") return fr_tree_type_165_title(inputs)
	if (locale === "it") return it_tree_type_165_title(inputs)
	if (locale === "ja") return ja_tree_type_165_title(inputs)
	if (locale === "ko") return ko_tree_type_165_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_165_title(inputs)
	if (locale === "ru") return ru_tree_type_165_title(inputs)
	if (locale === "th") return th_tree_type_165_title(inputs)
	if (locale === "tr") return tr_tree_type_165_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_165_title(inputs)
	return zh_tw_tree_type_165_title(inputs)
});